module.exports = __webpack_public_path__ + "img/articulated-dumper.5e78309.png";